module.exports = __webpack_public_path__ + "img/KSC00808.a469e979.jpg";